import React from 'react';

export const PatternIcon = ({ size, color, svgClass, isOverDue }: any) => {
  return (
    <>
      <svg
        width={size || '110'}
        height="210"
        viewBox="0 0 159 234"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClass}
      >
        <g filter="url(#filter0_d_4303_15053)" stroke={isOverDue ? 'red' : ''}>
          <path
            d="M29.1325 225.304C27.2356 226.436 24.7749 225.818 23.6936 223.892C11.4794 202.132 4.87638 177.647 4.51276 152.654C4.1297 126.327 10.6836 100.362 23.5157 77.3699C36.3478 54.3779 55.0059 35.1687 77.6148 21.6731C99.0778 8.86159 123.383 1.62758 148.316 0.59942C150.523 0.508394 152.34 2.27857 152.373 4.48748L154.463 148.163C154.484 149.592 153.741 150.923 152.514 151.656L29.1325 225.304Z"
            fill={color || '#8298B5'}
          />
        </g>
        <defs>
          <filter
            id="filter0_d_4303_15053"
            x="0.49707"
            y="0.596191"
            width="157.967"
            height="233.273"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_4303_15053"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_4303_15053"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
